import BaseDataStore from '@/components/base/store/BaseDataStoreV2'
// import moment from 'moment'
const storeName = 'S0801PressSetting'
const serviceName = 'S0801SettingService'

/*
    {
      column: 'col-6', // column size
      data: 'status', // data name
      type: 'select', // component type : text,textarea,number,checkbox,switch,radio,file,date,time,dateRange,select,autoComplete,combobox,rangeSlider,slider,ttc_category,ttc_tag,ttc_price,ttc_policy
      label: 'status', // label
      props: any // component props
    }
*/
const storeDef = {
  ACTION: {
    // base actions : doAdd, doEdit, getEdit, doBrowse, doDelete, getRead
    // custom actions
    // TODO: accept string without storeName/serviceName
    doBrowse: {
      store: storeName + '/doBrowse',
      api: serviceName + '.doBrowseForPress'
    }
  },
  PROPERTY: {
    // base properties : row, rows, pagination, searchInfo, orderBy
    // custom properties

  }
}

const tableDef = {
  viewDef: [
    { text: 'Key', value: 'setting_key' },
    { text: 'Code', value: 'setting_code' },
    { text: 'Value', value: 'setting_value' },
    { text: 'Action', value: 'actions', sortable: false }
  ],
  optionDef: {}
}

const editDef = {

  viewDef: [
    {
      column: 'col-12',
      data: 'setting_key',
      type: 'text',
      rules: 'required',
      label: 'Key'
    },
    {
      column: 'col-12',
      data: 'setting_code',
      type: 'text',
      rules: 'required',
      label: 'Code'
    },
    {
      column: 'col-12',
      data: 'setting_value',
      type: 'text',
      rules: 'required',
      label: 'Value'
    }
  ],
  optionDef: {}
}

const BaseConst = {
  version: 1,
  storeName: storeName,
  serviceName: serviceName,
  storeConst: storeDef,
  componentDef: {
    table: tableDef,
    edit: editDef

  }
}
const FnConst = new BaseDataStore(BaseConst)
export default FnConst
